import { Logger } from '../support/Logger';
import { LoginNudgeAlert } from '../utils/useIfLoggedIn';

/**
 * Offered to a reader who opens a care recipient's link before signing in, from the daily caseload
 * email for instance. Signing in returns to the same url.
 */
export class SignInToOpenCareMap {
    static inject = () => [LoginNudgeAlert, Logger];
    constructor(private loginNudge: LoginNudgeAlert, private logger: Logger) {}

    offer = async (): Promise<void> => {
        try {
            await this.loginNudge.show({
                trackingFrom: 'Care Recipient Link',
                message: 'Sign in to open this care recipient. If you have access, their care profile opens once you are signed in.'
            });
        } catch (err: any) {
            // Closing the sign-in window comes back here as an abort; signing in reloads the app instead.
            if (err?.errorCode !== 'login-aborted') {
                this.logger.error(err);
            }
        }
    };
}
